package com.example.hukakmp.web

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.example.hukakmp.App
import com.example.hukakmp.auth.GoogleAuthProvider
import com.example.hukakmp.initializeWebFirebase

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initializeWebFirebase()

    ComposeViewport(viewportContainerId = "webApp") {
        App(GoogleAuthProvider())
    }
}
